<template>
  <div class="addressSelectModal">
    <!-- sel:{{proviceId_sel}} {{cityId_sel}};{{proviceText_sel}}{{cityText_sel}}{{distText_sel}}
    id:{{proviceId}} {{cityId}}; -->
    <select name="" id="" @change="changeProvice" v-model="proviceId_sel">
      <option value="">请选择省</option>
      <option v-for="(list,index) in proviceWordArr" :value="list.region_id">{{list.region_name}}</option>
    </select>
    <select name="" id="" @change="changeCity" v-model="cityId_sel">
      <option value="">请选择市</option>
      <option v-for="(list,index) in cityWordArr" :value="list.region_id">{{list.region_name}}</option>
    </select>
    <select name="" id="" v-model="distId_sel" @change="changeDist" >
      <option value="">请选择区</option>
      <option v-for="(list,index) in distWordArr" :value="list.region_id">{{list.region_name}}</option>
    </select>
  </div>
</template>

<script>
  import {    utils  } from '@/common/common.js'
  import {    ajaxPost  } from '@/common/request.js'
  export default {    name: 'authmodal',
    data() {
      return {
        proviceWordArr:[],
        cityWordArr:[],
        distWordArr:[],
        proviceId_sel:'',
        cityId_sel:"",
        distId_sel:"",
        proviceText_sel:"",
        cityText_sel:"",
        distText_sel:"",
        // proviceId:'',
        // proviceText:'',
        // cityId:'',
        // cityText:'',
        // distId:'',
        // distText:'',

      }
    },
    props: ['proviceId', 'proviceText','cityId','cityText','distId','distText'],
    components: {},
    watch:{
      proviceId(newV,oldV) {
          // do something
          this.proviceId_sel=newV
          this.getAjax(this.proviceId_sel,"city")
      },
      cityId(newV,oldV) {
          // do something
          this.cityId_sel=newV
          this.getAjax(this.cityId_sel,"dist")
      },
      distId(newV,oldV) {
          // do something
          this.distId_sel=newV
      }
    },
    computed: {
    },
    methods: {
      getProviceNameById(id){
        let arr=this.proviceWordArr
        let result=''
        arr.forEach(function(item,index){
          if(item.region_id==id){
            result=item.region_name
            return false
          }
        })
        return result
      },
      getCityNameById(id){
        let arr=this.cityWordArr
        let result=''
        arr.forEach(function(item,index){
          if(item.region_id==id){
            result=item.region_name
            return false
          }
        })
        return result
      },
      getDistNameById(id){
        let arr=this.distWordArr
        let result=''
        arr.forEach(function(item,index){
          if(item.region_id==id){
            result=item.region_name
            return false
          }
        })
        return result
      },
      sendNewAddress(){
        let obj={
          proviceId:this.proviceId_sel,
          cityId:this.cityId_sel,
          distId:this.distId_sel,
          proviceText:this.proviceText_sel,
          cityText:this.cityText_sel,
          distText:this.distText_sel,
        }
        // console.log(obj)
        this.$emit('changeSelect',obj);
      },
      changeProvice(){
        this.cityWordArr=[]
        this.distWordArr=[]
        this.cityId_sel=''
        this.cityText_sel=''
        this.distId_sel=''
        this.distText_sel=''
        this.proviceText_sel=this.getProviceNameById(this.proviceId_sel)
        this.getAjax(this.proviceId_sel,"city")
        this.sendNewAddress()

      },
      changeCity(){
        this.distWordArr=[]
        this.distId_sel=''
        this.distText_sel=''
        this.cityText_sel=this.getCityNameById(this.cityId_sel)
        this.getAjax(this.cityId_sel,"dist")
        this.sendNewAddress()
      },
      changeDist(){
        this.distText_sel=this.getDistNameById(this.distId_sel)
        this.sendNewAddress()
      },
      init(){
        this.proviceId_sel=this.proviceId
        this.cityId_sel=this.cityId
        this.distId_sel=this.distId
        this.proviceText_sel=this.proviceText
        this.cityText_sel=this.cityText
        this.distText_sel=this.distText
      },
      getAjax(parentId,type){
        let arg={}
        let  _this=this
        if(type=='provice'){//查询省
          arg={
            parentId:0
          }
          ajaxPost('/globalRegionInfo/regionInfo', arg).then(function(res) {
              if (res.errorCode == 200) {
                _this.proviceWordArr=res.data
              }
          }, function(res) {   })
        }else if(type=='city'){//查询市
          arg={
            parentId:parentId
          }
          ajaxPost('/globalRegionInfo/regionInfo', arg).then(function(res) {
              if (res.errorCode == 200) {
                _this.cityWordArr=res.data
              }
          }, function(res) {   })
        }else if(type=='dist'){//查询区
          arg={
            parentId:parentId
          }
          ajaxPost('/globalRegionInfo/regionInfo', arg).then(function(res) {
              if (res.errorCode == 200) {
                _this.distWordArr=res.data
              }
          }, function(res) {   })
        }
      },
      getAddress_provice(){
        this.getAjax(0,'provice')
      },
      refresh() {
        // this.$emit('submitSucess');
      },
      submit() {
      },
      close() {
      }
    },
    mounted() {
      this.getAddress_provice()
      // console.log( this.proviceId)
      this.init()
    }
  }
</script>

<style scoped lang="scss">
  .addressSelectModal{
    // border:1px solid blue;
    display:inline-block;
    select{
      border-radius: 4px;padding:5px;border:1px solid #ccc;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/addressSelect.vue